[
  {
    "id": "PROMO_001",
    "titulo": "Semana Resolvida",
    "descricao": "Monte 5 dias de alimentação com almoço, jantar, snack e bebida. Sem improviso, sem desperdício.",
    "badge": "Mais popular",
    "cta": "Montar minha semana",
    "icone": "🥗",
    "destaque": true
  },
  {
    "id": "PROMO_002",
    "titulo": "Recompra Programada",
    "descricao": "Receba um lembrete automático para renovar seu kit antes de acabar. Sua rotina nunca para.",
    "badge": "Novidade",
    "cta": "Ativar lembrete",
    "icone": "🔔",
    "destaque": false
  },
  {
    "id": "PROMO_003",
    "titulo": "Indique e Ganhe",
    "descricao": "Indique a Rê Leve para alguém e receba um benefício especial na sua próxima compra.",
    "badge": "Exclusivo",
    "cta": "Quero indicar",
    "icone": "🤝",
    "destaque": false
  },
  {
    "id": "PROMO_004",
    "titulo": "Kit Escritório Saudável",
    "descricao": "Alimentação saudável para equipes, reuniões e compras coletivas. Condições especiais para grupos.",
    "badge": "Para equipes",
    "cta": "Simular compra coletiva",
    "icone": "🏢",
    "destaque": false
  },
  {
    "id": "PROMO_005",
    "titulo": "Dia Leve",
    "descricao": "Resolva almoço, jantar e lanche em um único kit. Prático, saudável e sem complicação.",
    "badge": "Começo fácil",
    "cta": "Montar kit do dia",
    "icone": "🌿",
    "destaque": false
  }
]
